// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2C-el","footer":"Form_footer__2zc35"};